export default "__VITE_ASSET__c3ef8dfb__"